import moment from 'moment';
import formatter from 'pages/ScheduleCalendar/duck/formatter';
import utils from 'pages/ScheduleCalendar/duck/utils';

/**
 * Extract common shift details (position, hours, timeRange) from a shift object
 * @param {Object} shift - The shift object
 * @returns {Object} Object containing position, start, end, hours, timeRange
 */
export function getShiftDetails(shift) {
  let position = '';
  let start = null;
  let end = null;
  let hours = 0;
  let timeRange = '';

  if (shift) {
    start = moment(shift.start_at).local().clone();
    end = moment(shift.end_at).local().clone();
    timeRange = formatter.formattedShiftTimeRange(shift);
    const diff = moment.duration(end.diff(start));
    hours = parseFloat(diff.asHours()).toFixed(2);
    if (isNaN(hours)) {
      hours = '0.00';
    }
    position = typeof shift.primary_job === 'string' ? shift.primary_job : '';
  }
  return { position, start, end, hours, timeRange };
}
